import { render, staticRenderFns } from "./liveClassStudentListCertificationrecords.vue?vue&type=template&id=722e5991"
import script from "./liveClassStudentListCertificationrecords.vue?vue&type=script&lang=js"
export * from "./liveClassStudentListCertificationrecords.vue?vue&type=script&lang=js"
import style0 from "./liveClassStudentListCertificationrecords.vue?vue&type=style&index=0&id=722e5991&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports